export default "__VITE_ASSET__DGVMLovp__"